import React from 'react'

function FacebookIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='40'
      height='40'
      viewBox='0 0 60 60'
      fill='none'
    >
      <path
        d='M60 30.0005C60 13.4313 46.5689 0 30 0C13.4311 0 0 13.4313 0 30.0005C0 44.9741 10.9689 57.3876 25.3111 59.6366V38.6718H17.6933V30.0005H25.3111V23.3915C25.3111 15.8714 29.7911 11.7202 36.6444 11.7202C39.9289 11.7202 43.36 12.3069 43.36 12.3069V19.6892H39.5778C35.8533 19.6892 34.6889 22.0004 34.6889 24.3737V30.0005H43.0089L41.68 38.6718H34.6889V59.6366C49.0311 57.3876 60 44.9741 60 30.0005Z'
        fill='#6267AC'
      />
      <path
        d='M41.6703 38.6699L42.9991 29.9988H34.6792V24.3721C34.6792 21.9987 35.8392 19.6876 39.568 19.6876H43.3503V12.3054C43.3503 12.3054 39.9192 11.7188 36.6347 11.7188C29.7814 11.7188 25.3014 15.8699 25.3014 23.3899V29.9988H17.6836V38.6699H25.3014V59.6343C26.8303 59.8743 28.3947 59.9987 29.9903 59.9987C31.5858 59.9987 33.1503 59.8743 34.6792 59.6343V38.6699H41.6703Z'
        fill='white'
      />
    </svg>
  )
}

export default FacebookIcon
